import { render, staticRenderFns } from "./voucher-amount-summary.vue?vue&type=template&id=20a52842&"
import script from "./voucher-amount-summary.vue?vue&type=script&lang=js&"
export * from "./voucher-amount-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports